import React from 'react';
import { Formik, Form } from 'formik';
import { Grid, Button, MenuItem } from '@mui/material';
import FormikTextField from '../../../../commons/formik/formikTextField';
import FormikSelect from '../../../../commons/formik/formikSelect';
import { StyledPaper } from '../../../../styled/paper';

const AgenciasFilter = ({ initialValues, onSearch, onClear }) => {
    return (
        <StyledPaper.Container sx={{ mb: 2 }}>
            <Formik
                initialValues={initialValues}
                onSubmit={(values) => onSearch(values)}
                enableReinitialize
            >
                {({ resetForm }) => (
                    <Form>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <FormikTextField name="razonSocial" label="Razón Social" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormikSelect name="estado" label="Estado" variant="outlined">
                                    <MenuItem value="activas">Activas</MenuItem>
                                    <MenuItem value="inactivas">Inactivas</MenuItem>
                                    <MenuItem value="todas">Todas</MenuItem>
                                </FormikSelect>
                            </Grid>

                            <Grid item xs={12} sm={4} display="flex" justifyContent="flex-end" gap={2} alignItems="center">
                                <Button
                                    variant="text"
                                    onClick={() => {
                                        resetForm();
                                        onClear();
                                    }}
                                >
                                    Limpiar
                                </Button>
                                <Button variant="contained" color="primary" type="submit">
                                    Buscar
                                </Button>
                            </Grid>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </StyledPaper.Container>
    );
};

export default AgenciasFilter;
